"use client";

import { TranslationScopes } from "@finbackoffice/enums";
import { IModalForwardRefPropsV2 } from "contexts";
import { forwardRef, ForwardRefExoticComponent, ReactNode, RefAttributes } from "react";
import Modal from "components/base/modal/Modal";
import { ModalStyleTypeEnum } from "components/base/modal/constants/modal-config";
import { ModalTypes } from "utils/constants";
import Translate from "components/base/translate/Translate";
import Button from "components/base/button/Button";
import styles from "./responsible-gaming.module.sass";

type IConfirmationModalProps = {
    text: ReactNode;
    error: ReactNode;
    handleClose: () => void;
    onConfirm: () => void;
    loading: boolean;
};

const ConfirmationModal: ForwardRefExoticComponent<
    IConfirmationModalProps & RefAttributes<IModalForwardRefPropsV2>
> = forwardRef(({ text, handleClose, loading, onConfirm, error }, ref) => {
    return (
        <Modal
            ref={ref}
            type={ModalTypes.RESPONSIBLE_GAMING_CONFIRMATION}
            styleConfigType={ModalStyleTypeEnum.Confirm}
            maskClosable={false}
            closeButton
            priority
            animateVariant="opacity"
            styleClass={styles.confirmModal}>
            <>
                <div className={styles.confirmModalHeader}>
                    <Translate
                        tid="account_responsible_gaming_modal_header"
                        namespace={TranslationScopes.UserAccount}
                    />
                </div>
                <div className={styles.confirmModalContent}>
                    <p>{text}</p>
                    {error}
                </div>

                <div className={styles.confirmModalBtns}>
                    <Button
                        type="button"
                        variant="secondary"
                        data-testid="cancel-modal-button"
                        onClick={() => handleClose()}>
                        <Translate tid="base_cancel" />
                    </Button>
                    <Button
                        type="button"
                        variant="primary"
                        data-testid="confirm-modal-button"
                        disabled={loading}
                        onClick={onConfirm}>
                        <Translate
                            tid="account_responsible_gaming_confirm"
                            namespace={TranslationScopes.UserAccount}
                        />
                    </Button>
                </div>
            </>
        </Modal>
    );
});

export default ConfirmationModal;
